import { authedFetch } from './authedFetch';

const API_URL = process.env.REACT_APP_API_URL;

export async function fetchCapstoneStatus(getToken) {
  return authedFetch(getToken, '/api/capstone/status');
}

export async function saveCapstoneSubmission(getToken, { title, questionStatement, essayText, sourcesCited, submit }) {
  return authedFetch(getToken, '/api/capstone/submission', {
    method: 'POST',
    body: JSON.stringify({ title, questionStatement, essayText, sourcesCited, submit }),
  });
}

// Returns { questions, examToken }. The questions carry no answer key --
// grading happens server-side against the paper the token authorises
// (ADR-0010), so this now requires auth.
export async function fetchDiplomaExamQuestions(getToken) {
  return authedFetch(getToken, '/api/quiz/diploma-exam?count=50');
}

// Submits answers, not a score. The server grades and returns the attempt
// plus a per-question review.
export async function submitExamAttempt(getToken, { examToken, answers }) {
  return authedFetch(getToken, '/api/capstone/exam/attempts', {
    method: 'POST',
    body: JSON.stringify({ examToken, answers }),
  });
}

// --- Reviewer surface (ADR-0005) -------------------------------------------
// These only succeed for allowlisted reviewers; the backend authorizes
// independently, so hiding the UI is convenience, not access control.

export async function fetchReviewerStatus(getToken) {
  return authedFetch(getToken, '/api/capstone/review/whoami');
}

export async function fetchReviewQueue(getToken, { status = 'submitted', page = 0 } = {}) {
  const params = new URLSearchParams({ status, page: String(page) });
  return authedFetch(getToken, `/api/capstone/review/submissions?${params}`);
}

export async function fetchSubmissionForReview(getToken, id) {
  return authedFetch(getToken, `/api/capstone/review/submissions/${id}`);
}

export async function recordReviewDecision(getToken, id, { decision, reviewerNotes, rubricScores }) {
  return authedFetch(getToken, `/api/capstone/review/submissions/${id}/decision`, {
    method: 'POST',
    body: JSON.stringify({ decision, reviewerNotes, rubricScores }),
  });
}

// --- Certificates (ADR-0009) -----------------------------------------------

export async function fetchMyCertificate(getToken) {
  return authedFetch(getToken, '/api/certificates/me');
}

export async function issueCertificate(getToken) {
  return authedFetch(getToken, '/api/certificates/issue', { method: 'POST' });
}

// Public: no auth, so a third party can check a claimed diploma.
export async function verifyCertificate(code) {
  const res = await fetch(`${API_URL}/api/certificates/verify/${encodeURIComponent(code)}`);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) return { valid: false, error: body.error || 'Verification failed.' };
  return body;
}

// Coursework waivers (ADR-0013). Reviewer-only; the server authorizes
// independently of whether the UI chooses to render this.
export async function fetchWaivers(getToken) {
  return authedFetch(getToken, '/api/capstone/review/waivers');
}

export async function grantWaiver(getToken, { clerkUserId, reason }) {
  return authedFetch(getToken, '/api/capstone/review/waivers', {
    method: 'POST',
    body: JSON.stringify({ clerkUserId, reason }),
  });
}

export async function revokeWaiver(getToken, clerkUserId) {
  return authedFetch(getToken, `/api/capstone/review/waivers/${clerkUserId}`, {
    method: 'DELETE',
  });
}
